import React from 'react';
import { Row, Col, Alert, Button, Upload } from 'antd';
import { connect } from 'dva';
import _cloneDeep from 'lodash/cloneDeep';
import Address from 'components_business/Address/Index.js';
import styles from './Index.less';
import ErrorInfo from './ErrorInfo.js';
import Table from './Table.js';
import { uploadExcelUrl } from '../../../../../../services/operation.js';

@connect(({ operationChargeItemPublishChargeItemSteps, loading, AddressBook }) => ({
  selectedRowKeys: operationChargeItemPublishChargeItemSteps.selectedRowKeys,
  loadingDownload: loading.effects['operationChargeItemPublishChargeItemSteps/downloadExcel'],
  loadingUpload: operationChargeItemPublishChargeItemSteps.step3NotificationUploadLoading,
  fileList: operationChargeItemPublishChargeItemSteps.step3NotificationFileList,
  uploadResponse: operationChargeItemPublishChargeItemSteps.step3NotificationUploadResponse,
  chargeTarget: AddressBook.chargeTarget,
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
}))
export default class UploadExcel extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectMember = this.handleSelectMember.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleOk = this.handleOk.bind(this);

    this.state = {
      tableList: props.initialDataSource || [],
    };
  }

  handleOk({ userList }) {
    this.setState({
      tableList: _cloneDeep(userList),
    });

    const resultList = [];
    userList.forEach(item => {
      resultList.push({
        id: item.id,
        userName: item.name,
        gradeName: item.lastDepartName,
        className: item.curDepartName,
      });
    });

    this.handleDownload(resultList);
  }

  handleDownload(users) {
    const { selectedRowKeys, dispatch, publishSchool } = this.props;

    return dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/downloadExcel',
      commodityIds: selectedRowKeys,
      users,
      orgId: publishSchool.key,
      orgName: publishSchool.label,
    });
  }

  handleSelectMember() {
    const { publishSchool: { key } } = this.props;
    this.props.dispatch({
      type: 'AddressBook/saveOrgId',
      orgId: key,
    });

    this.props.dispatch({
      type: 'AddressBook/setChargeTarget',
      payload: {
        visible: true,
        addressBook: [],
        selected: [],
        defaultCheckedKey: [],
        schoolName: '',
        exceptNodes: {},
      },
    });
  }

  render() {
    const {
      loadingDownload,
      loadingUpload,
      fileList,
      selectedRowKeys,
      uploadResponse,
      publishSchool: { key },
    } = this.props;

    const { tableList } = this.state;

    const props = {
      withCredentials: true,
      accept: '.xlsx',
      action: uploadExcelUrl,
      data: {
        commodityIds: selectedRowKeys,
        orgId: key,
      },
      name: 'importExcel',
      beforeUpload: file => {
        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/saveStep3NotificationFileList',
          file,
        });

        return true;
      },
      fileList,
      onChange: ({ file }) => {
        const { dispatch } = this.props;

        if (file.status === 'uploading') {
          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadLoading',
            loading: true,
          });

          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadResponse',
            response: {},
          });
        } else if (file.status === 'done') {
          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadLoading',
            loading: false,
          });

          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadResponse',
            response: {
              ...file.response.data,
              valid: file.response.data.valid || false,
              code: file.response.code,
              msg: file.response.msg,
            },
          });
        } else if (file.status === 'error') {
          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadLoading',
            loading: false,
          });

          dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/saveUploadResponse',
            response: {
              ...file.response.data,
              msg: file.response.msg,
            },
          });
        }
      },
    };

    return (
      <div className={styles.root}>
        <Row>
          <Col span={24} className="ant-alert ant-alert-info ant-alert-no-icon">
            <span className="ant-alert-message">
              <div className="title">上传收费名单：</div>
              <div className="step1">
                <span>第一步：下载模版并填写收费名单</span>
                <Button
                  type="primary"
                  size="small"
                  ghost
                  icon="download"
                  loading={loadingDownload}
                  onClick={this.handleSelectMember}
                >
                  下载样例
                </Button>
              </div>
              <div className="step2">
                <span>第二步：上传收费名单</span>
                <Upload {...props}>
                  <Button type="primary" size="small" ghost icon="upload" loading={loadingUpload}>
                    {fileList.length === 0 ? '上传文件' : '重新上传'}
                  </Button>
                </Upload>
              </div>
            </span>
          </Col>
        </Row>

        {uploadResponse.valid === false && <ErrorInfo />}

        {uploadResponse.valid === true && <Table />}

        <Alert style={{ display: 'none' }} />

        <Address
          renderContent="table"
          tableList={tableList}
          onOk={this.handleOk}
          entitySigns="student_group"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/UploadExcel/Index.js